import React from "react";
import styles from "./H2.scss";
import classNames from "classnames";

export const H2 = ({ children, margin }) => {
    return (
        <h2
            className={classNames(styles.h2, {
                [styles.marginNone]: margin === "none"
            })}
        >
            {children}
        </h2>
    );
};
